import { Route } from '/@/modules/core/app/constants/api.constants';
import { BaseAsyncResource } from '@/modules/core/app/resources/BaseAsyncResource';

export class ExportResource extends BaseAsyncResource {
  /**
   * @param exportType
   * @param resourceId
   * @param params
   * @return {Promise<*>}
   */
  async download(exportType, resourceId, params = {}) {
    return this.getBlob(`${Route.EXPORT_PDF}/${exportType}${resourceId ? '/' + resourceId : ''}`, {
      params: params
    });
  }

  async downloadWithToken(exportType, params = {}) {
    return this.getBlob(`${Route.EXPORT_PDF}/${exportType}?token=${params.token}`, params);
  }
}

export default new ExportResource();
